import React from 'react'

import { CardBulletPoint } from '@frame/ui-components/card-bullet-point'
import { P } from '@frame/ui-primitives/p'

import bank from '@frame/images/bank.svg'
import piggyBankSavings from '@frame/images/piggyBankSavings.svg'
import wallet from '@frame/images/wallet.svg'
import { useStore } from '@frame/lib/stores/useStore'
import { cn } from '@frame/lib/utils/cn'

export function MortgageBankContent() {
  const { verifierName } = useStore((state) => ({
    verifierName: state.session?.originating_party_display_name,
  }))
  const displayVerifierName = verifierName || 'Your lender'
  return (
    <>
      <P className={cn('mb-2', 'text-moss-700')}>
        {displayVerifierName} needs a complete picture of your income and assets
      </P>
      <CardBulletPoint imgSrc={wallet} title="Checking" />
      <CardBulletPoint imgSrc={piggyBankSavings} title="Savings" />
      <CardBulletPoint imgSrc={bank} title="Assets" />
    </>
  )
}
